import { IMAGE_MIME_TYPE, MS_EXCEL_MIME_TYPE, PDF_MIME_TYPE } from "@mantine/dropzone";

const MAX_FILE_SIZE = 5 * 1024 ** 2;

const ALLOWED_FILE_TYPES = [...PDF_MIME_TYPE, ...MS_EXCEL_MIME_TYPE, ...IMAGE_MIME_TYPE]

export { MAX_FILE_SIZE, ALLOWED_FILE_TYPES }